module.exports = __webpack_public_path__ + "img/circle_l.ef4f36e5.png";